import React, { useState, useRef, useEffect } from "react";
import { RingLoader } from "react-spinners";
import styled from "styled-components";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const TableContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 20px;
`;

const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    max-width: 800px;
    margin-top: 20px;
`;

const TableHeader = styled.th`
    border: 1px solid #ddd;
    padding: 8px;
    background-color: #f2f2f2;
`;

const TableRow = styled.tr`
    border: 1px solid #ddd;
    padding: 8px;

    &:nth-child(even) {
        background-color: #f9f9f9;
    }
`;

const TableCell = styled.td`
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
`;

const Checkbox = styled.input`
    margin-right: 10px;
`;

const IconGeneratorViewer = (props) => {
    const {
        titleSelect,
        titleIcon,
        titleDownloadSelected,
        titleDownload,
        titleDelete,
        titleReady,
        titleCancel,
        titleGenerate,
        tip1,
    } = props.attributes;

    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showViewer, setShowViewer] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [generatedFiles, setGeneratedFiles] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});

    const imageRef = useRef(null);

    const handleGenerate = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowViewer(false);

        const requestBody = {
            fileid: props.fileId,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/generateIcons?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setGeneratedFiles(responseData.files);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowViewer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const reloadPage = () => {
        setShowViewer(true);
        location.reload();
    };

    const handleFileSelect = (fileName) => {
        setSelectedFiles((prevSelectedFiles) => ({
            ...prevSelectedFiles,
            [fileName]: !prevSelectedFiles[fileName],
        }));
    };

    const handleDownloadSelected = () => {
        const selectedFileUrls = generatedFiles
            .filter((file) => selectedFiles[file.name])
            .map((file) => file.url);
        selectedFileUrls.forEach((url) => {
            const link = document.createElement("a");
            link.href = url;
            link.download = getFileName(url);
            link.click();
        });
    };

    return (
        <Container>
            {showViewer && (
                <>
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                border: "1px solid #333",
                            }}
                        >
                            <img
                                src={props.imageUrl}
                                alt="Viewer"
                                onLoad={() => setImageLoaded(true)}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        </div>
                        <div className="px-4 py-2">
                            <ButtonContainer>
                                <StyledButton onClick={handleGenerate}>
                                    {titleGenerate}
                                </StyledButton>
                            </ButtonContainer>
                        </div>
                    </div>
                </>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleCancel}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <ButtonContainer>
                        <a
                            href={downloadUrl}
                            download={getFileName(downloadUrl)}
                            onClick={handleDownload}
                        >
                            <StyledButton>{titleDownload}</StyledButton>
                        </a>
                        <a className="pl-2" onClick={handleDownload}>
                            <StyledButtonDelete>
                                {titleDelete}
                            </StyledButtonDelete>
                        </a>
                    </ButtonContainer>
                    <TableContainer>
                        <Table>
                            <thead>
                                <tr>
                                    <TableHeader>{titleSelect}</TableHeader>
                                    <TableHeader>{titleIcon}</TableHeader>
                                    <TableHeader>{titleDownload}</TableHeader>
                                </tr>
                            </thead>
                            <tbody>
                                {generatedFiles.map((file) => (
                                    <TableRow key={file.name}>
                                        <TableCell>
                                            <Checkbox
                                                type="checkbox"
                                                checked={
                                                    !!selectedFiles[file.name]
                                                }
                                                onChange={() =>
                                                    handleFileSelect(file.name)
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>{file.name}</TableCell>
                                        <TableCell>
                                            <a
                                                href={file.url}
                                                download={getFileName(file.url)}
                                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                            >
                                                {titleDownload}
                                            </a>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </Table>
                        <ButtonContainer>
                            <StyledButton onClick={handleDownloadSelected}>
                                {titleDownloadSelected}
                            </StyledButton>
                        </ButtonContainer>
                    </TableContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleCancel}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default IconGeneratorViewer;
